<div
  class="flex items-center gap-3 rounded-md border p-3"
  [ngClass]="appliedClasses()"
>
  <!-- icon -->
  <svg-icon [src]="appliedIcon()" />

  <div class="flex flex-col gap-2">
    <!-- heading -->
    @if (heading()) {
      <h3 class="typography-headings-small">
        {{ heading() }}
      </h3>
    }

    <!-- message -->
    <p class="typography-body-default">
      {{ message() }}
    </p>

    <!-- action -->
    @if (hasAction() && !actionTemplateRef()) {
      <p-button
        variant="outlined"
        size="small"
        [severity]="appliedSeverity()"
        [label]="actionLabel()"
        (click)="onAction()"
      />
    } @else if (actionTemplateRef()) {
      <ng-container *ngTemplateOutlet="actionTemplateRef()" />
    }
  </div>

  <!-- dismiss -->
  @if (isDismissible()) {
    <p-button
      class="ml-auto"
      variant="text"
      size="small"
      pTooltip="Close"
      tooltipPosition="left"
      [severity]="appliedSeverity()"
      (click)="onDismiss()"
    >
      <ng-template #icon>
        <svg-icon src="/assets/icons/general/close.svg" />
      </ng-template>
    </p-button>
  }
</div>
